
import { useEffect } from 'react'
import Select from 'react-select'
import { FinancialYearDDLAPI, MonthDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const MonthDataDDL = (props) => {
    const { Month, setMonth, HMonth = false, MLable, Flag, screenType, isCompulsory } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const d = new Date();
    let month = d.getMonth();

    useEffect(() => {
        const data = { UserID, token }
        dispatch(MonthDDLAPI({ data }))
    }, [])

    const { MonthData } = useSelector(state => state.MonthDDLData)

    // console.log('HMonth', Month)

    useEffect(() => {
        handleMonthDDL()
    }, [MonthData])


    const handleMonthDDL = () => {
        // console.log(DeptDDLDataa)
        if (MonthData && MonthData.table && MonthData.table.length > 0) {
            let list = MonthData.table.map((item, index) => ({
                value: item.id,
                label: item.month_Name,
            }))
            if (screenType == "DailyData") {
                if (Month?.ID > 0) {
                    setMonth({
                        DDL: list,
                        ID: Month?.ID,
                        Label: Month?.Label,
                    })
                } else {
                    setMonth({
                        DDL: list,
                        ID: HMonth != 0 && HMonth ? list[HMonth - 1].value : list[month].value,
                        Label: HMonth != 0 && HMonth ? list[HMonth - 1].label : list[month].label,
                    })
                }
            }
            else if (screenType == 'commonalldashboardreport') {
                setMonth({
                    DDL: list,
                    ID: 0,
                    Label: "Select...",
                })
            }
            else if (screenType == "SearchFetch") {
                setMonth({
                    DDL: list,
                    ID: HMonth != 0 && HMonth ? list[HMonth - 1].value : list[month].value,
                    Label: HMonth != 0 && HMonth ? list[HMonth - 1].label : list[month].label,
                })
            }
            else {
                setMonth({
                    DDL: list,
                    // ID: HMonth != 0 && HMonth ? list[HMonth-1].value : list[month].value,
                    // Label: HMonth != 0 && HMonth ? list[HMonth-1].label: list[month].label,
                    ID: Month?.ID,
                    Label: Month?.Label,

                    // ID: HMonth ? list[HMonth].value : list[month].value,
                    // Label: HMonth ? list[HMonth].value : list[month].label,
                    // ID: HMonth ? HMonth : 0,
                    // Label: MLable ? MLable : 'Select...',
                    // ID: 0,
                    // Label: "Select...",
                })
            }
        }
        else {
            setMonth({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }


    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Month {isCompulsory && <AstricSign />} </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                styles={{
                    option: (provided, state) => ({
                        ...provided,
                        color: 'black'
                    })
                }}
                isSearchable
                maxMenuHeight={150}
                value={{ value: Month.ID, label: Month.Label }}
                onChange={(e) => {
                    e ?
                        setMonth({ ...Month, ID: e.value, Label: e.label })
                        :
                        setMonth({ ...Month, ID: 0, Label: "Select..." })

                }}
                options={Month.DDL}
            />
        </div>
    )
}